import {ThreePLTrainAlertsService} from "../services/threepl-train-alerts.service";

export const TRAIN_VOUCHERS_PAGE_SIZE = 20;

export const SUPPLY_ACCOUNTS_PAGE_SIZE = 20;

export const SUPPLY_ACCOUNTS_SEARCH_DEBOUNCE_MS = 1000;

export const PRINT_DELAY_MS = 1000;

export const TRAIN_VOUCHER_CREATE_ERROR_ALERTS: Record<number, keyof ThreePLTrainAlertsService> = {
  412005: "trainVoucherCreateMissingRelatedDepotsError",
  412006: "trainVoucherCreateMissingSupplierError",
  412007: "trainVoucherCreateMissingProviderError",
  412008: "trainVoucherCreateMissingThreePLProviderSettingsError",
  412009: "trainVoucherCreateMissingThreePLBaseUrlError",
  412010: "trainVoucherCreateMissingThreePLKeyError",
  412011: "trainVoucherCreateMissingThreePLSecretError",
  412012: "trainVoucherCreateMissingExtraDataError",
};

export const VOUCHERS_PRINT_WINDOW_FEATURES = "width=1200,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no";

export const TRAIN_VOUCHER_CREATE_ERROR = "THREEPL_TRAIN_VOUCHER_CREATE_ERROR";
